export const NO_MEASUREMENT_RETRY_URLS = ['/measurementsets', '/measurementset'];
